const textFieldModalEquipServiceGroup = {
  name: 'Section Name'
};

export default textFieldModalEquipServiceGroup;
